// Frontend permission helper. NOTE: this only controls visibility.
// The backend independently enforces every permission (source of truth).
export function isStaffAdmin(user) {
  return !!user && ["admin", "super_admin"].includes(user.role);
}

export function hasPerm(user, perm) {
  if (!user) return false;
  if (isStaffAdmin(user)) return true;
  const eff = user.effective_permissions || user.permissions || [];
  return eff.includes(perm);
}

export function isStaff(user) {
  return !!user && ["admin", "super_admin", "agent"].includes(user.role);
}

export function roleHome(user) {
  if (!user) return "/login";
  if (["admin", "super_admin"].includes(user.role)) return "/admin";
  if (user.role === "agent") return "/agent/dashboard";
  return "/dashboard";
}
